import { useEffect, useMemo } from "react"
import useCourses from "../../hooks/use-courses"
import { useFormStore } from "../../stores/use-form-store"
import type { FieldProps } from "../../types/form-types"
import { SelectField } from "./select"

export const ProgramTypeField = ({
	form,
	field,
	commonAttributes,
}: FieldProps) => {
	const { config, submissionValues, applicationId } = useFormStore()
	const { useGetProgramTypes } = useCourses()
	const { data: programTypes } = useGetProgramTypes({
		universityId: config?.university_id ?? "",
		batchId: config?.batch_id ?? "",
		applicationId: applicationId ?? "",
		type: config?.type ?? "FORM",
		widgetId: config?.widget_id ?? "",
	})

	const options = useMemo(() => {
		if (!programTypes) return []

		return programTypes.map(programType => ({
			label: programType.label,
			value: programType.value,
		}))
	}, [programTypes, submissionValues])

	useEffect(() => {
		if (submissionValues && submissionValues[field.field_id]) {
			const value = submissionValues[field.field_id]
			if (value != "") form.setValue(field.field_id, value)
		}
	}, [options])

	return (
		<SelectField
			form={form}
			field={field}
			commonAttributes={commonAttributes}
			optionsPreSet={options}
		/>
	)
}
